$(document).ready(function() {

  $('.mobile-wrap').on('click', function() {
    $('.line-burger').toggleClass('line-active');
    $('.header__list').slideToggle();
  });

  var $header = $('.header');
  var headerHeight = $header.outerHeight();

  $(window).resize(function() {
    if ($(window).width() > 1023) {
      $('.header__list').attr('style', '');
      $('.line-burger').removeClass('line-active');
    }
    if (!$('.line-burger').hasClass('line-active')) {
      headerHeight = $header.outerHeight();
    }
  });

  $('a[href^="#"]').not('.js-modal-open').on('click', function(e) {
    var target = $(this).attr('href');

    if (target === '#' || !$(target).length) {
      return;
    }

    e.preventDefault();

    if ($('.line-burger').hasClass('line-active')) {
      $('.header__list').slideUp();
      $('.line-burger').removeClass('line-active');
    }

    var offset = headerHeight;

    $('html, body').stop().animate({
      scrollTop: $(target).offset().top - offset
    }, 600);
  });

  var $modal = $('#modal-contact');

  function closeModal() {
    $modal.removeClass('modal--active');
    $('body').removeClass('modal-open');
  }

  $('.js-modal-open').on('click', function(e) {
    e.preventDefault();
    $modal.addClass('modal--active');
    $('body').addClass('modal-open');
    $('.line-burger').removeClass('line-active');
    $('.header__list').attr('style', '');
  });

  $modal.on('click', function(e) {
    if (e.target === this) {
      closeModal();
    }
  });

  $('.modal__close').on('click', closeModal);

  $(document).on('keyup', function(e) {
    if (e.key === 'Escape') {
      closeModal();
    }
  });

  function validate(input, length, regExp, error, phone) {

    $(input).on('blur keyup', function () {
      var value = $(this).val();
      var that = $(this);

      regExp = regExp == '' ? /./ : regExp;

      if (phone === true) {
        bool_reg = !regExp.test(value);
      } else {
        bool_reg = regExp.test(value);
      }

      if (value.length > length && value !== '' && bool_reg) {
        that.removeClass('form-fail').addClass('form-done');
        $(error).slideUp();
      } else {
        that.removeClass('form-done').addClass('form-fail');
        $(error).slideDown();
      }
    });
  }

  function validateCheckbox(input, error) {
    var isChecked = $(input).is(':checked');

    if (isChecked) {
      $(error).slideUp();
    } else {
      $(error).slideDown();
    }
  }

  function validateCheckboxWatch(input, error) {
    $(input).on('change', function () {
      var isChecked = $(input).is(':checked');

      if (isChecked) {
        $(error).slideUp();
      } else {
        $(error).slideDown();
      }
    });
  }

  // деакцивация кнопки если есть поле с ошибкой

  function disBtn(input, btn, bool) {
    var input = $(input);
    input.on('blur keyup', function () {

      if (input.hasClass('form-fail') || bool == true) {
        $(btn).attr('disabled', 'disabled');
      } else {
        $(btn).removeAttr('disabled');
      }

    });
  }

  // для проверки при нажатии

  function valClick(input, length, regExp, error, phone) {
    var value = $(input).val();

    regExp = regExp == '' ? /./ : regExp;

    if (phone === true) {
      bool_reg = regExp.test(value);
    } else {
      bool_reg = !regExp.test(value);
    }

    if (value.length < length || value === '' || bool_reg) {
      $(input).addClass('form-fail');
      $(error).slideDown();
    }
  }

  //  деакцивация кнопки при нажатии

  function disBtnClick(input, btn) {
    var input = $(input);

    if (input.hasClass('form-fail')) {
      $(btn).attr('disabled', 'disabled');
      return false;
    } else {
      return true;
    }
  }

  $('input[type="tel"]').mask("+38 (999) 999-99-99");

  var regName = /^[a-zA-Zа-яА-ЯёЁєЄIiЇї'`]+/;
  var regEmail = /[-.\w]+@[-.\w]+\.[-.\w]+/i;
  var regPhone = /[_]/i;

  $('#sub_btn').on('click', function () {
    sendForm();
    return false;
  });

  function sendForm() {
    var name = $('#sub_name').val();
    var company = $('#sub_company').val();
    var email = $('#sub_email').val();
    var phone = $('#sub_phone').val();
    var city = $('#sub_city').val();
    var zip = $('#sub_zip').val();
    var address = $('#sub_address').val();

    validate('#sub_name', 1, regName, '.subscription__error--name');
    validate('#sub_email', 1, regEmail, '.subscription__error--email');
    validate('#sub_phone', 1, regPhone, '.subscription__error--phone', true);
    validate('#sub_city', 1, '', '.subscription__error--city');
    validate('#sub_address', 1, '', '.subscription__error--address');
    validateCheckbox('#sub_age', '.subscription__error--age');
    disBtn('#sub_name, #sub_email, #sub_phone, #sub_city, #sub_address', '#sub_btn');

    valClick('#sub_name', 1, regName, '.subscription__error--name');
    valClick('#sub_email', 1, regEmail, '.subscription__error--email');
    valClick('#sub_phone', 1, regPhone, '.subscription__error--phone', true);
    valClick('#sub_city', 1, '', '.subscription__error--city');
    valClick('#sub_address', 1, '', '.subscription__error--address');
    validateCheckboxWatch('#sub_age', '.subscription__error--age');
    var btn_bool = disBtnClick('#sub_name, #sub_email, #sub_phone, #sub_city, #sub_address', '#sub_btn');

    if (btn_bool && $('#sub_age').is(':checked')) {
      $.ajax({
        url: themeVar.url,
        type: 'POST',
        data: {
          action: 'subscribe',
          name: name,
          email: email,
          company: company,
          phone: phone,
          city: city,
          zip: zip,
          address: address,
        },
      }).done(function (data) {
        $('#sub_name, #sub_email, #sub_phone, #sub_city, #sub_address, #sub_company, #sub_zip').val('').removeClass('form-done');
        $('#sub_age').prop('checked', false);
        var text = 'Ваше повідомлення відправлене!';

        $('.msg-modal').html(text).addClass('msg-modal-active');
        setTimeout(function () {
          $('.msg-modal').removeClass('msg-modal-active');
        }, 2500);
      });
    }
  }

  $('#c_btn').on('click', function () {
    sendFormContact();
    return false;
  });

  function sendFormContact() {
    var name = $('#c_name').val();
    var company = $('#c_company').val();
    var email = $('#c_email').val();
    var phone = $('#c_phone').val();
    var msg = $('#c_message').val();

    validate('#c_name', 1, regName, '.modal__error--name');
    validate('#c_email', 1, regEmail, '.modal__error--email');
    disBtn('#c_name, #c_email', '#c_btn');

    valClick('#c_name', 1, regName, '.modal__error--name');
    valClick('#c_email', 1, regEmail, '.modal__error--email');
    disBtn('#c_name, #c_email', '#c_btn');
    var btn_bool = disBtnClick('#c_name, #c_email', '#c_btn');

    if (btn_bool) {
      $.ajax({
        url: themeVar.url,
        type: 'POST',
        data: {
          action: 'contact',
          name: name,
          email: email,
          company: company,
          phone: phone,
          msg: msg,
        },
      }).done(function (data) {
        $('#c_name, #c_email, #c_phone, #c_company, #c_message').val('').removeClass('form-done');
        var text = 'Ваше повідомлення відправлене!';
        closeModal();
        $('.msg-modal').html(text).addClass('msg-modal-active');
        setTimeout(function () {
          $('.msg-modal').removeClass('msg-modal-active');
        }, 2500);
      });
    }
  }
})
